import './screenshot-or-video.scss';
